const $ = require("jquery");

/* closes submenu in header */
function closeSubMenu($this) {
    $this
        .children("ul")
        .removeClass("js-showElement")
        .addClass("js-hideElement");
    $this
        .children(".menu__sub")
        .removeClass("js-showElement")
        .addClass("js-hideElement");
}

$(document).ready(function() {
    // Remove no-js class
    $("html").removeClass("no-js");
    const mediaQuery = window.matchMedia("(max-width: 1199px)");

    if (mediaQuery.matches) {
        $(".show-filters-button").attr("aria-expanded", false);
        $(".show-filters-button").attr("aria-controls", "filters-content");
        $(".content").attr("id", "filters-content");
    }

    $(".show-filters-button").on("click", function() {
        if ($(this).attr("aria-expanded") === "false") {
            $(this).attr("aria-expanded", true);
        } else {
            $(this).attr("aria-expanded", false);
        }
    });

    $("#toggleMenu").on("click", function() {
        if ($(this).hasClass("js-open")) {
            $("#navigation > ul > li)").removeClass("js-showElement");
            $("#navigation > ul > li)").removeClass("js-showElement");
            $(this).removeClass("js-open");

            $(this).attr("aria-expanded", false);
        } else {
            $("#navigation > ul > li").addClass("js-showElementt");
            $(this).addClass("js-open");

            $(this).attr("aria-expanded", true);
        }

        return false;
    });

    // Add plus mark to li that have a sub menu
    $('li:has("ul") > button').append('<span class="arrowDown"></span>');

    // sub menu
    // ------------------------

    // When interacting with a li that has a sub menu
    $(document).on("keyup", function(e) {
        if ((e.key == "Escape") | (e.keyCode == "13")) {
            var $this = $('li:has("ul")');
            closeSubMenu($this);
        }
    });

    $('li:has("ul")').on("mouseover keyup click mouseleave", function(e) {
        var button = $(this).find("button");

        button.attr("aria-expanded", false);
        // If either -
        // tabbing into the li that has a sub menu
        // hovering over the li that has a sub menu
        if ((e.keyCode === 9) | (e.type === "mouseover")) {
            // Show sub menu
            $(this)
                .children("ul")
                .removeClass("js-hideElement");
            $(this)
                .children(".menu__sub")
                .removeClass("js-hideElement");
            $(this)
                .children("ul")
                .addClass("js-showElement");
            $(this)
                .children(".menu__sub")
                .addClass("js-showElement");
            button.attr("aria-expanded", true);
        }

        if ((e.key == "Escape") | (e.keyCode == "13")) {
            if (
                $(this)
                    .children("ul")
                    .hasClass("js-showElement")
            ) {
                // hide sub menu
                closeSubMenu($(this));
            }
        }

        if ((e.key == "Escape") | (e.keyCode == "13")) {
            if (
                $(this)
                    .children("ul")
                    .hasClass("js-showElement")
            ) {
                // hide sub menu
                closeSubMenu($(this));
            }
        }

        // If mouse leaves li that has sub menu
        if (e.type === "mouseleave") {
            button.attr("aria-expanded", false);
            closeSubMenu($(this));
            // hide sub menu
        }

        // If clicking on li that has a sub menu
        if (e.type === "click") {
            button.attr("aria-expanded", true);
            if (
                !$(this)
                    .children("ul")
                    .hasClass("js-clickShowElement")
            ) {
                $('li:has("ul")')
                    .children("ul")
                    .removeClass("js-clickShowElement");
                $(this)
                    .children("ul")
                    .addClass("js-clickShowElement");
                $("body").click(function(e) {
                    if (e.target.tagName != "BUTTON") {
                        $('li:has("ul")')
                            .children("ul")
                            .removeClass("js-clickShowElement");
                    }
                });
            }
        } // end click event
    });

    // Tabbing through Levels of sub menu
    // ------------------------

    // If key is pressed while on the last link in a sub menu
    $("li > ul > li:last-child > a").on("keydown", function(e) {
        // If tabbing out of the last link in a sub menu AND not tabbing into another sub menu
        if (
            e.keyCode == 9 &&
            $(this)
                .parent("li")
                .children("ul").length == 0
        ) {
            // Close this sub menu
            $(this)
                .parent("li")
                .parent("ul")
                .removeClass("js-showElement");
            $(this)
                .parent("li")
                .parent("ul")
                .addClass("js-hideElement");

            $('li:has("ul"').attr("aria-expanded", "false");
        }

        if ((e.key == "Escape") | (e.keyCode == "13")) {
            // Close this sub menu
            $(this)
                .parent("li")
                .parent("ul")
                .removeClass("js-showElement");
            $(this)
                .parent("li")
                .parent("ul")
                .addClass("js-hideElement");
        }
    });

    // $("nav ul").on("focus", ".menu__child", function(){
    //     $(this).closest("ul").addClass("focused-ul");
    //     }).on("blur", ".menu__child", function(){
    //     $(".focused-ul").removeClass("focused-ul");
    // });

    // document.addEventListener('keyup', function(event) {
    //     if (event.keyCode === 27) {
    //         $(".focused-ul").removeClass("focused-ul");
    //     }
    //   });

    // add touch support (dependancy: modernizr)
    // $(".touch .dropdown li").has("ul").on("mouseenter",function(){
    //     $(this).addClass("hover");
    // }).on("mouseleave",function(){
    //     $(this).removeClass("hover");
    // });
});
